import { Component, OnInit , Output ,Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';


@Component({
  selector: 'app-special-occasion',
  templateUrl: './special-occasion.component.html',
  styleUrls: ['./special-occasion.component.scss']
})
export class SpecialOccasionComponent implements OnInit {

  @Output() specialOccasion : EventEmitter<boolean> = new EventEmitter;
  @Input () cartonid = "";
  sepicalList : any = [];
  getPaginationCount;
  page = 1;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];

  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration

  ) {
  }
 
  ngOnInit() {
    this.getPointStructureUser()
  }
  getPointStructureUser(){
    this.apiService.getHeaders(this.apiConfig.specialOcceranceList + `?program_id=1&carton_campaign_id=${this.cartonid}&page=${this.page}`).subscribe((res : any)=>{
      console.log(res)
      this.sepicalList = res.body.data.pagination_data;
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
       if(this.sepicalList.legth == 0){
         this.specialOccasion.emit(false)
       }
      //2) for excelData
      this.excelData = res.body.data.excel_download_data;
      for (var k in this.excelData[0]) {
        if (typeof this.excelData[k] !== 'function') {
          console.log("Key is " + k.replace(/_/g, ' '));
          this.excelFormat.header = k.replace(/_/g, ' ');
          this.excelFormat.key = k
          this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
          console.log(this.excelArray)
        }
      }
    })
  }

  DownloadReportExcel() {
    console.log("here")
    this.exportExcelService.DownloadReportExcel('Special_Occasion', this.excelData, this.excelArray);
  }
  
  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getPointStructureUser();
  }

  uploadExcel(id){
    this.router.navigate(["/hubAdmin/carton-upload/"+id + "/"+ 3+ "/" +this.cartonid])
}
getType(id){
 if(id == 1)  return "Percentage" 
 if(id == 2)  return "Flat"
}
}
